import { render, staticRenderFns } from "./StudentAdmin.vue?vue&type=template&id=2ab8aa17&scoped=true&"
import script from "./StudentAdmin.vue?vue&type=script&lang=js&"
export * from "./StudentAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StudentAdmin.vue?vue&type=style&index=0&id=2ab8aa17&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab8aa17",
  null
  
)

export default component.exports